export default __webpack_public_path__ + "static/media/airport.a51f9800.svg";